import * as React from 'react'
import { cn } from '@/lib/utils'
import { controlClassName } from './input'

/** A styled multiline text field that forwards its ref and native textarea props. */
export function Textarea({ ref, className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn('flex min-h-24 px-control-x py-2', controlClassName, className)}
      ref={ref}
      {...props}
    />
  )
}
